import React from 'react';
import { Card } from '@/components/ui/card';
import { CheckCircle2, XCircle, Clock, AlertCircle } from 'lucide-react';
import { TestResults } from '@/hooks/useTestRunner';

interface TestStatisticsProps {
  results: TestResults | null;
  isRunning: boolean;
}

const TestStatistics = ({ results, isRunning }: TestStatisticsProps) => {
  const stats = [
    {
      label: 'Total de Testes',
      value: results?.totalTests ?? 0,
      icon: Clock,
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10',
    },
    {
      label: 'Testes Passando',
      value: results?.passed ?? 0,
      icon: CheckCircle2,
      color: 'text-green-500',
      bgColor: 'bg-green-500/10',
    },
    {
      label: 'Testes Falhando',
      value: results?.failed ?? 0,
      icon: XCircle,
      color: 'text-red-500',
      bgColor: 'bg-red-500/10',
    },
    {
      label: 'Tempo de Execução',
      value: results?.duration ? `${results.duration.toFixed(2)}s` : '0s',
      icon: AlertCircle,
      color: 'text-yellow-500',
      bgColor: 'bg-yellow-500/10',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card key={stat.label} className="p-6 bg-card border-border">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">{stat.label}</p>
                <p className={`text-3xl font-bold mt-2 ${isRunning ? 'animate-pulse' : ''}`}>
                  {stat.value}
                </p>
              </div>
              <div className={`p-3 rounded-lg ${stat.bgColor}`}>
                <Icon className={`h-6 w-6 ${stat.color}`} />
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default TestStatistics;
